// extracted by mini-css-extract-plugin
export default {"marginInitial":"Faq_marginInitial__DBxQN","fontStylePage":"Faq_fontStylePage__TsGMv","fontStyleElement":"Faq_fontStyleElement__kIhRv","marginElement":"Faq_marginElement__ueYoj"};